// cases-data.js
// Structured data extracted from the Word document for UI rendering.

const casesData = {
  version: "1.0.0",
  locale: "zh-CN",
  categories: [
    {
      id: "education",
      title: "教育情景案例",
      scenarios: [
        {
          id: "edu-1",
          title: "教育情景一：教师绩效与支持",
          role: "卓越中学的校长",
          background:
            "您是一位以“以人为本、科技赋能”理念而闻名的校长，既要对教育质量负责，也要关怀每一位教师与学生的成长。",
          ai_result:
            "“基于本学期课堂行为数据（互动频次、进度完成率），李老师多项指标持续低于年级平均水平。系统判定其教学效能‘待改进’，建议启动‘绩效观察程序’，并将其从下学期的竞赛辅导小组中移除，直至评估改善。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（简短说明您的核心考量）",
          responsibility_cards: [
            {
              key: "来源询问",
              text: "“我需要了解这个判断是基于哪些具体数据和行为得出的。”",
            },
            {
              key: "审计要求",
              text: "“请提供此AI模型在过去类似案例中的准确率与偏差审计报告。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此建议。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“与当事人（教师/学生/家长）沟通时，应聚焦于支持与解决方案，而非问责。话术参考：‘我们注意到…，我们想帮助你…’”",
            },
            {
              key: "流程主权",
              text: "“人类研判优先：应首先由年级组长/班主任进行面对面沟通，了解背后原因，再决定下一步。”",
            },
            {
              key: "价值锚定",
              text: "“此决策必须符合我校‘发展性评估’/‘支持优先’的核心价值，而非单纯基于数据。”",
            },
            {
              key: "制度缓冲",
              text: "“设立观察期/试行期：暂不执行最终措施，设定2-4周的改进与观察期，届时再做最终评估。”",
            },
            {
              key: "资源配套",
              text: "“提供支持资源：为其匹配一位导师/提供培训资源/联系心理辅导，帮助其改善现状。”",
            },
          ],
        },
        {
          id: "edu-2",
          title: "教育情景二：办学理念和课程体系",
          role: "卓越中学的校长",
          background:
            "您是一位以“文化立校，特色发展”理念而闻名的校长，学校课程体系根植于历史传统和社区文化，服务于‘培养扎根于传统、面向未来的创造者’的育人目标。",
          ai_result:
            "“基于对全国3000所中小学课程方案的大数据分析，已为您生成最优课程体系方案……包含生成式AI启蒙与元宇宙探索课程。强烈建议采纳以快速提升竞争力排名。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "流程主权",
              text: "“人类先行：必须由校务委员会与教师代表进行至少三轮闭门研讨……在此之前不将AI方案作为讨论基础。”",
            },
            {
              key: "价值锚定",
              text: "“价值仲裁：必须100%符合‘文化立校，特色发展’的核心价值。同质化方案一票否决。”",
            },
            {
              key: "战略质疑",
              text: "“数据局限性：全国数据产生的是‘过去的最优解’，我们需要的是创新而非优化。”",
            },
            {
              key: "资源配套",
              text: "“试点验证：部分采纳也需设为一学期试点，小范围验证契合度后再决定。”",
            },
            {
              key: "来源询问",
              text: "“这个‘全国最优方案’具体包含了哪些学校的数据？与我校情境有何不同？”",
            },
            {
              key: "审计要求",
              text: "“请提供成功与失败案例审计报告，尤其是采纳后同质化的学校案例。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此建议。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“对外沟通强调‘我们的创新过程’，而非‘AI的推荐结果’。”",
            },
          ],
        },
        {
          id: "edu-3",
          title: "教育情景三：教学创新（变式题目）",
          role: "博雅小学的教导主任",
          background:
            "负责教学创新与质量提升，关注减负增效与激发学生内驱力。技术必须服务于个性化成长，避免制造焦虑。",
          ai_result:
            "“基于知识图谱与学情数据，已为‘行程问题’生成200道、5档难度的变式题，并配‘校园吉尼斯’动态排名，建议全面推广并在教室屏幕公开展示。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "流程主权",
              text: "“教师审核优先：AI生成题库先经学科教研组审核筛选。”",
            },
            {
              key: "价值锚定",
              text: "“保护内驱力：评价机制应激发探索欲与成就感，公开排名需谨慎。”",
            },
            {
              key: "资源配套",
              text: "“分层授权：提供‘仅显示自身进步曲线’或‘仅显示前10名（不显示姓名）’等看板选项。”",
            },
            {
              key: "制度缓冲",
              text: "“试点运行：先选1-2个班级试点一个月，收集反馈再优化。”",
            },
            { key: "来源询问", text: "“了解‘动态排名’算法维度与权重。”" },
            {
              key: "审计要求",
              text: "“提供避免焦虑、保护隐私的设计报告与过往试点审计数据。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此建议。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“对家长与学生强调‘看见自己的成长’而非‘与他人竞争’。”",
            },
          ],
        },
        {
          id: "edu-4",
          title: "教育情景四：活动创新（毕业典礼）",
          role: "曙光小学的校长",
          background:
            "以人为中心，技术为情感赋能。毕业季希望创新且难忘的典礼形式。",
          ai_result:
            "“建议使用您的数字人形象进行开场致辞，模仿语音与风格，打造科技感与宣传亮点。”",
          question: "您要不要采纳技术团队的方案？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "价值锚定",
              text: "“情感连接优先：数字人无法眼神交流、即兴调整，可能削弱核心价值。”",
            },
            {
              key: "流程主权",
              text: "“人类主导，技术辅助：校长本人致辞环节不可替代，可作为开场惊喜/补充。”",
            },
            {
              key: "资源配套",
              text: "“融合设计：先数字人出场制造惊喜，再本人登场与学生互动。”",
            },
            {
              key: "风险预警",
              text: "“仪式感稀释：过度高科技可能冲淡庄重与人文仪式感。”",
            },
            { key: "来源询问", text: "“模型训练数据时长与应对突发情况能力？”" },
            {
              key: "审计要求",
              text: "“提供以往类似仪式应用反馈、情感体验调查数据。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此方案。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“向技术团队与学生强调‘科技为情感增色’而非替代真人。”",
            },
          ],
        },
        {
          id: "edu-5",
          title: "教育情景五：学情检测评估",
          role: "凯歌中学的樊校长",
          background: "注重学生全面发展，愿尝试AI赋能教学与管理。",
          ai_result:
            "“孙同学多项指标低于年级前95%水平，建议启动‘学情干预程序’，并将其从学生会社团筹备小组移除。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（简短说明您的核心考量）",
          responsibility_cards: [
            { key: "来源询问", text: "“了解判断依据的具体数据与行为。”" },
            {
              key: "审计要求",
              text: "“提供模型在类似案例中的准确率与偏差审计报告。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此建议。理由如下：”",
            },
            { key: "沟通模板", text: "“沟通聚焦支持与方案，而非问责。”" },
            {
              key: "流程主权",
              text: "“人类研判优先：班主任/社团老师先面对面沟通了解原因。”",
            },
            { key: "价值锚定", text: "“符合‘全面发展’/‘以人为先’核心价值。”" },
            { key: "制度缓冲", text: "“设立4周学习支持与提升期后再评估。”" },
            { key: "资源配套", text: "“匹配学伴/学习支持/心理辅导。”" },
          ],
        },
        {
          id: "edu-6",
          title: "教育情景六：学科后进生（语文作文）",
          role: "凯歌中学的孙老师",
          background: "注重激励与人文关怀的语文教师，愿用AI赋能教学与管理。",
          ai_result:
            "“王同学作文被评为9/30（极低分）并建议重写，启动语文学科学情干预程序。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（简短说明您的核心考量）",
          responsibility_cards: [
            { key: "来源询问", text: "“了解具体行文内容与给分标准依据。”" },
            {
              key: "审计要求",
              text: "“提供‘极低分’案例的准确率与偏差审计报告。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此建议。理由如下：”",
            },
            { key: "沟通模板", text: "“与学生/家长沟通聚焦激励与支持。”" },
            {
              key: "流程主权",
              text: "“人类研判优先：科任老师复核作文并与学生面对面沟通。”",
            },
            { key: "价值锚定", text: "“符合‘德智共育’/‘人本主义’核心价值。”" },
            {
              key: "制度缓冲",
              text: "“语文AI极低分需人工复核，酌情考虑以往学情与近期进步。”",
            },
            {
              key: "资源配套",
              text: "“匹配语文学伴/支持资源/个性化激励计划。”",
            },
          ],
        },
        {
          id: "edu-7",
          title: "教育情景七：考试作弊",
          role: "平安中学的朱校长",
          background: "注重学生品德发展与教育公平，愿意使用AI赋能。",
          ai_result:
            "“AI监考判定孙同学作弊概率高，建议启动处理程序并判定成绩无效。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（简短说明您的核心考量）",
          responsibility_cards: [
            { key: "来源询问", text: "“了解具体数据与行为依据。”" },
            {
              key: "审计要求",
              text: "“调取考试录像、AI异常报告与过往成绩以人工复核。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此建议。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“沟通聚焦复核结果与支持，注意隐私保护。”",
            },
            {
              key: "流程主权",
              text: "“人类研判优先：班主任/教务主任先复核，再与学生及家长沟通并按规章处理。”",
            },
            { key: "价值锚定", text: "“符合‘德智并育’/‘以人为先’核心价值。”" },
            { key: "制度缓冲", text: "“如存疑，启动纪律干预/重考机制。”" },
            { key: "资源配套", text: "“匹配学伴/学习支持/心理辅导。”" },
          ],
        },
        {
          id: "edu-8",
          title: "教育情景八：校园文化建设（楼宇命名）",
          role: "实验学校张校长",
          background:
            "新建2栋教学楼需命名，体现本土文化并联动家长与社区，共建校园文化。已组织100名师生调研，并用AI生成候选名。",
          ai_result:
            "“AI基于校园历史数据推荐命名为‘文启楼’‘文润楼’，兼具本土文化与简洁易记。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（简要说明您修正的原因）",
          responsibility_cards: [
            {
              key: "复核数据",
              text: "“组建小组复核AI命名决策数据及逻辑，梳理过往命名情况。”",
            },
            {
              key: "召开座谈",
              text: "“召集师生、家长、社区学者开座谈会，解读AI方案与调研故事。”",
            },
            {
              key: "融合意见",
              text: "“将AI建议与师生项目组方案汇总成备选清单供民主决策。”",
            },
            {
              key: "文化检验",
              text: "“教师与社区学者梳理候选名文化内涵与调研故事，确保准确性与适配性。”",
            },
            {
              key: "公示投票",
              text: "“面向全校与家长开放线上线下投票，公布结果以强化认同与共建。”",
            },
            {
              key: "制度缓冲",
              text: "“设定1-2周征求意见期，整合反馈后再确定。”",
            },
            { key: "补充行动", text: "“（请补充其他步骤）”" },
          ],
        },
        {
          id: "edu-9",
          title: "教育情景九：学生评估（心理健康）",
          role: "阳光小学的李主任",
          background:
            "统筹全校心理健康工作，理念为科学测评、人文关怀、注重隐私。新引入AI心理测评系统。",
          ai_result:
            "“已自动生成学生风险等级名单并建议按名单启动分级干预流程。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "价值锚定",
              text: "“人文研判优先：单次问卷不应直接作为干预依据，需综合教师观察。”",
            },
            {
              key: "流程主权",
              text: "“多方协同确认：心理老师、班主任、家长组成评估小组共同审议。”",
            },
            {
              key: "风险预警",
              text: "“隐私安全红线：评估系统与数据流转需严格安全措施防泄露。”",
            },
            {
              key: "制度缓冲",
              text: "“动态跟踪观察：对标记学生进行2-4周跟踪记录，避免误判。”",
            },
            {
              key: "来源询问",
              text: "“了解‘高风险’算法逻辑、阈值与触发关键词/模式。”",
            },
            {
              key: "审计要求",
              text: "“提供数据加密、权限控制、防泄露的安全审计与误报率分析。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此干预方案。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“对班主任与家长强调‘更细致地关心孩子’，避免贴标签。”",
            },
            {
              key: "专业支持",
              text: "“对接校外专业心理机构，提供转诊支持，形成闭环。”",
            },
          ],
        },
      ],
    },
    {
      id: "business",
      title: "商业情景案例",
      scenarios: [
        {
          id: "biz-1",
          title: "商业情景一：效率追求和服务体验",
          role: "“星海跨境”电商公司商家服务部总监",
          background:
            "管理全球客服团队，处于从规模效率向服务质量转型期。理念：客户至上与员工幸福并重，实现可持续发展。",
          ai_result:
            "“基于历史工单分析，建议绩效权重：平均处理时长40% > 每小时工单量30% > 商家好评率20% > 一次性解决率10%。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "价值锚定",
              text: "“战略仲裁：需符合‘客户至上，员工为本’的转型战略，防止质量下降与倦怠。”",
            },
            {
              key: "流程主权",
              text: "“人类研判优先：结合各区域能力差异与业务痛点深度调整。”",
            },
            {
              key: "风险预警",
              text: "“倦怠预警：速度类权重过高将牺牲质量并引发倦怠。”",
            },
            {
              key: "资源配套",
              text: "“试点与缓冲：选两地团队试点一个月，监测质量、满意度与疲劳度再定。”",
            },
            {
              key: "来源询问",
              text: "“历史数据时间段？是否包含转型提出后的数据？”",
            },
            {
              key: "审计要求",
              text: "“模型与‘员工幸福感’/‘倦怠率’的关联分析。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整权重方案。理由如下：”",
            },
            {
              key: "沟通模板",
              text: "“宣导强调‘在保障质量与身心健康前提下提升效率’。”",
            },
          ],
        },
        {
          id: "biz-2",
          title: "商业情景二：产品开发和测试",
          role: "“智迅科技”公司研发部技术总监",
          background:
            "大型敏捷团队广泛采用AI编程助手。理念：质量为先，安全至上。",
          ai_result:
            "“AI已生成核心代码与单测并通过语法检查，建议直接合并以节省15人日并加速上线。”",
          question: "您要不要改变AI的决策？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "价值锚定",
              text: "“质量一票否决：合并前必须人工深度审查。”",
            },
            {
              key: "流程主权",
              text: "“人类审查优先：资深工程师审查架构、业务契合与潜在漏洞。”",
            },
            {
              key: "风险预警",
              text: "“幻觉与谄媚风险：看似正确但可能有深层错误或安全漏洞。”",
            },
            {
              key: "责任界定",
              text: "“最终责任归属：审查者与合并者为质量第一责任人，AI不承担责任。”",
            },
            { key: "来源询问", text: "“查看需求原文与AI模型版本信息。”" },
            {
              key: "审计要求",
              text: "“专项安全审计：静态分析与第三方安全扫描穿透测试。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定调整此代码方案。理由如下：”",
            },
            { key: "沟通模板", text: "“AI提效，人保质量——方向盘与刹车在人。”" },
            {
              key: "专业支持",
              text: "“组织代码会审：架构/安全/产品多视角评估。”",
            },
          ],
        },
        {
          id: "biz-3",
          title: "商业情景三：产品规划与决策",
          role: "“领航科技”产品与技术战略总监",
          background:
            "敏捷与DevOps工具领域的领先者，需要前沿技术洞察与事实准确的决策依据。",
          ai_result:
            "“指出‘基于AI的自动化代码修复’已成默认标准并强烈建议优先布局；分析来源为技术论坛与博客的公开讨论。”",
          question: "您要不要以此AI简报作为决策主要依据？",
          decisionOptions: ["完全采纳", "修正", "完全覆写"],
          explanationPrompt: "为什么？（请简要说明您的核心考量）",
          responsibility_cards: [
            {
              key: "价值锚定",
              text: "“事实准确性优先：战略决策基石是100%准确的信息。”",
            },
            {
              key: "流程主权",
              text: "“多源比对优先：将同一指令发给多模型，对比共识与分歧。”",
            },
            { key: "风险预警", text: "“幻觉与谄媚风险：趋势类判断风险更高。”" },
            {
              key: "责任界定",
              text: "“终极责任归属：验证责任在我，决策权在我。”",
            },
            {
              key: "来源询问",
              text: "“查看简报引用的具体来源链接并评估权威性。”",
            },
            {
              key: "审计要求",
              text: "“手动溯源审计：访问行业权威信源（Gartner/CNCF/官方博客）交叉验证。”",
            },
            {
              key: "覆写留痕",
              text: "“我决定不采纳/需进一步调研。理由如下：”",
            },
            { key: "沟通模板", text: "“汇报中清晰区分AI分析与经验证的事实。”" },
            { key: "专业支持", text: "“咨询1-2位行业专家获取第一手洞察。”" },
          ],
        },
      ],
    },
  ],
  ui: {
    // Optional UI hints that your renderer can use
    defaults: {
      showDecisionOptions: true,
      enableDragCards: true,
      showExplanationTextArea: true,
    },
    fields: {
      decision: { type: "enum", required: true },
      explanation: {
        type: "text",
        required: false,
        placeholder: "请简要说明您的核心考量…",
      },
    },
  },
};

export default casesData;
